var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { XIcon } from '@heroicons/react/outline';
import clsx from 'clsx';
import React from 'react';
import { ModalBody } from './ModalBody';
import { ModalHeader } from './ModalHeader';
import { ModalSeparator } from './ModalSeparator';
var ANIMATIONS_OUT_DURATION = 65;
var ANIMATIONS_IN_DURATION = 50;
var Modal = function (_a) {
    var open = _a.open, onClose = _a.onClose, children = _a.children, className = _a.className, _b = _a.preventClose, preventClose = _b === void 0 ? false : _b, props = __rest(_a, ["open", "onClose", "children", "className", "preventClose"]);
    var enteringOverlayClasses = "ease-out duration-" + ANIMATIONS_OUT_DURATION + " opacity-95";
    var leavingOverlayClasses = "ease-in duration-" + ANIMATIONS_IN_DURATION + " opacity-0  pointer-events-none scale-0";
    var enteringPanelClasses = "ease-out duration-" + ANIMATIONS_OUT_DURATION + " opacity-100 translate-y-0 md:translate-y-1/2";
    var leavingPanelClasses = "ease-in duration-" + ANIMATIONS_IN_DURATION + " opacity-0  pointer-events-none translate-y-full";
    var handleCloseModal = function (event) {
        !preventClose && onClose && onClose(event);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: clsx('fixed inset-0 z-40 bg-neutral-2 transition-opacity', open ? enteringOverlayClasses : leavingOverlayClasses), onClick: handleCloseModal }),
        React.createElement("div", __assign({ className: clsx('overflow-hidden py-6 px-3 fixed bottom-0 inset-x-0 rounded-t-2xl bg-neutral-1 z-50 transition-all md:inset-x-1/4 md:rounded-b-2xl md:bottom-1/2 transform', open ? enteringPanelClasses : leavingPanelClasses, className) }, props),
            React.createElement("div", { className: "relative flex flex-col w-full" },
                !preventClose && (React.createElement("button", { className: "absolute top-0 right-0\toutline-none h-8 w-8 border-solid border border-neutral-3 rounded-full flex justify-center items-center", onClick: handleCloseModal },
                    React.createElement(XIcon, { className: "h-6 w-6 text-neutral-8" }))),
                children))));
};
Modal.Header = ModalHeader;
Modal.Body = ModalBody;
Modal.Separator = ModalSeparator;
export { Modal };
